module.exports = __webpack_public_path__ + "static/img/project-empty.7db26b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-empty.svg
// module id = 291
// module chunks = 0